/**
 * @generated SignedSource<<1e51285aafa194ce4dc49a7ecd64059a>>
 * @relayHash addb5f86511885dcd2ee609fd30ead50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8837953019067868952ebed7aae6f70b0bfc24e116d5c10fa1b1b1542c27a4be

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery$variables = {
  tenantId: string;
};
export type useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery$data = {
  readonly growthUnifiedProfile_siteProfile: {
    readonly functionalOnboardingContext: {
      readonly functionallyOnboarded: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery = {
  response: useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery$data;
  variables: useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tenantId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      }
    ],
    "concreteType": "GrowthUnifiedProfileSiteProfileResult",
    "kind": "LinkedField",
    "name": "growthUnifiedProfile_siteProfile",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "productKey",
            "value": "CONFLUENCE"
          }
        ],
        "concreteType": "GrowthUnifiedProfileFunctionalOnboardingResult",
        "kind": "LinkedField",
        "name": "functionalOnboardingContext",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "functionallyOnboarded"
          }
        ],
        "storageKey": "functionalOnboardingContext(productKey:\"CONFLUENCE\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "addb5f86511885dcd2ee609fd30ead50",
    "id": "8837953019067868952ebed7aae6f70b0bfc24e116d5c10fa1b1b1542c27a4be",
    "metadata": {},
    "name": "useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery",
    "operationKind": "query",
    "text": "query useCfind5291TemplateTouchpointFunctionalOnboardingContextQuery($tenantId:ID!){growthUnifiedProfile_siteProfile(tenantId:$tenantId){functionalOnboardingContext(productKey:CONFLUENCE){functionallyOnboarded}}}"
  }
};
})();

(node as any).hash = "6866df03aa7a9631e003fb9871147b21";

export default node;
